import CrudPaginationController from "./crud_pagination_controller";

export default class extends CrudPaginationController {

  static targets = [ "submit", "loading", "list", "form", "function", "maxDateTime", "minDateTime", "nextPage", "previousPage", "clear" ]

  PAGE_NUMBER = 0;
  FUNCTION = null;
  FILTER_PARAMETERS = ["start_date_time", "input_date_time", "select_xmit", "report_code_list"];

  connect() {
    this.siteNum = this.data.get("siteNum");
    this.loadList();

    this.submitTarget.addEventListener("mousedown", e =>
    {
      this.FUNCTION = "Filter";
    })

    this.submitTarget.addEventListener("click", e =>
    {
      let formData = new FormData(this.formTarget);
      let parameters = Array.from(formData.entries()).filter(a => this.FILTER_PARAMETERS.includes(a[0]));

      if(parameters.every(p => !p[1]) && this.FUNCTION == "Filter")
      {
        e.preventDefault();
        return;
      }

      this.showLoading();
    })

    this.PAGE_NUMBER = 0;

    this.clearTarget.addEventListener("click", e =>
    {
        let startDate = this.formTarget.querySelector('input[name="start_date_time"]'),
            endDate = this.formTarget.querySelector('input[name="input_date_time"]'),
            xmit = this.formTarget.querySelector('input[name="select_xmit"]').parentElement,
            reportCodes = this.formTarget.querySelector('input[name="report_code_list"]').parentElement;
        
        startDate._flatpickr.clear();
        endDate._flatpickr.clear();
        xmit.clear();
        reportCodes.clear();

        this.FUNCTION = "Clear";
        this.submitTarget.click();
    })
  }

  nextPage(e)
  {
    this.functionTarget.value = "PageUp";
    this.FUNCTION = "PageUp";
    
    let records = Array.from(this.listTarget.children);
    let maxRecord = records.find(rec => rec.dataset["maxDatetime"]),
        minRecord = records.find(rec => rec.dataset["minDatetime"])
    
    this.maxDateTimeTarget.value = (maxRecord) ? maxRecord.dataset["maxDatetime"] : null;
    this.minDateTimeTarget.value = (minRecord) ? minRecord.dataset["minDatetime"] : null;


    this.submitTarget.click();
  }

  previousPage(e)
  {
    this.functionTarget.value = "PageDown";
    this.FUNCTION = "PageDown";
    
    let records = Array.from(this.listTarget.children);
    let maxRecord = records.find(rec => rec.dataset["maxDatetime"]),
        minRecord = records.find(rec => rec.dataset["minDatetime"])
    
    this.maxDateTimeTarget.value = (maxRecord) ? maxRecord.dataset["maxDatetime"] : null;
    this.minDateTimeTarget.value = (minRecord) ? minRecord.dataset["minDatetime"] : null;
    
    this.submitTarget.click();
  }

  handleResponse(e)
  {
    let [doc, status, xhr] = e.detail;
    if((doc.success !== undefined && !doc.success) || !doc)
    {
      let toastEvent = new CustomEvent("show-toast", { detail: "An error occurred while loading history." })
      window.dispatchEvent(toastEvent);

      this.hideLoading();
      return;
    }

    if(this.FUNCTION == "Filter" || this.FUNCTION == "Clear")
    {
      this.previousPageTargets.forEach(t => t.classList.remove("hidden"));
      this.nextPageTargets.forEach(t => t.classList.add("hidden"));
      this.clearTarget.classList.remove("hidden");
    }
    else if(this.FUNCTION == "PageUp")
    {
      this.PAGE_NUMBER--;

      this.previousPageTargets.forEach(t => t.classList.remove("hidden"));
      if(this.PAGE_NUMBER == 0) this.nextPageTargets.forEach(t => t.classList.add("hidden"));
    }
    else
    {
      this.PAGE_NUMBER++;

      this.nextPageTargets.forEach(t => t.classList.remove("hidden"));
      if(doc.body.children.length < 19) this.previousPageTargets.forEach(t => t.classList.add("hidden"));
    }

    if(this.FUNCTION == "Clear")
    {
      this.clearTarget.classList.add("hidden");
    }


    this.listTarget.innerHTML = "";
    this.listTarget.append(...doc.body.children);
    if(this.listTarget.firstElementChild.dataset["empty"] == "true")
    {
      this.nextPageTargets.forEach(t => t.classList.add("hidden"));
      this.previousPageTargets.forEach(t => t.classList.add("hidden"));
    }

    this.hideLoading();


    this.minDateTimeTarget.value = null;
    this.maxDateTimeTarget.value = null;
    this.functionTarget.value = null;
  }

  loadList(params) {
    this.fetchForTarget(window.App.prefixedUrl(`/sites/${this.siteNum}/history/list?${this.paramsString()}&${params}`), this.listTarget)
      .then(() => {
        this.hideLoading();

        if(this.listTarget.children.length < 19)
        {
          this.previousPageTargets.forEach(x => x.classList.add("hidden"));
        }
      });
  }
}
